import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/view-mail/Main.css";

const Main = () => {
  const navigate = useNavigate();

  return (
    <div className="view-mail">
      <div className="mail-header">
        <img
          src="/images/view-mail1.png"
          alt="Mail Icon"
          className="mail-icon"
        />
        <img
          src="/images/view-mail2.png"
          alt="Mail Icon"
          className="mail-icon"
        />
      </div>
    </div>
  );
};

export default Main;
